import { Platforms } from "../api/types/autoEnum";

export enum MediaPlayerId {
  Anthology = Platforms.Anthology,
  YouTube = Platforms.YouTube_Music,
  Spotify = Platforms.Spotify,
}
